import type { ReactFlowInstance } from 'reactflow';
import { v4 as uuid } from 'uuid';
import type { CustomNode } from '@src/components/custom-nodes/types';
import type { GenericInfoContentItem } from '@src/scenario-editor/render-utils/types';
import type { AnyZodObject } from 'zod';

interface GetCommonNodeProps {
  reactFlowInstance?: ReactFlowInstance;
  handles: { t: boolean; b: boolean };
  type: string;
  title: string;
  cardType?: string;
  titleDescription?: string;
  position: { x: number; y: number };
  nodeType: string;
  branchId: string;
  parentBranchId: string;
  parentNodeId: string;
  bgColor?: string;
  svgIcon?: string;
  nodeInfoContent?: GenericInfoContentItem[];
  iconFromSVG?: boolean;
  validationSchema?: AnyZodObject;
  rootLabelField?: string;
  isDraggable?: boolean;
  restDataPropsToAdd?: Record<string, unknown>;
}

export const getCommonNode = ({
  handles,
  type,
  title,
  titleDescription,
  position,
  nodeType,
  cardType = 'default',
  branchId,
  parentBranchId,
  parentNodeId,
  bgColor,
  svgIcon,
  nodeInfoContent,
  iconFromSVG,
  validationSchema,
  rootLabelField,
  isDraggable,
  restDataPropsToAdd
}: GetCommonNodeProps) => {
  const newNode = {
    id: uuid(),
    type,
    selected: true,
    position,
    data: {
      title,
      titleDescription,
      handles,
      message: '',
      nodeType,
      bgColor,
      svgIcon,
      nodeInfoContent,
      iconFromSVG,
      validationSchema,
      rootLabelField,
      cardType,
      isDraggable,
      ...(restDataPropsToAdd ?? {}),
    },
    branchId,
    parentBranchId,
    parentNodeId,
  };

  return newNode as CustomNode;
}
